import { GENERAL_AUDIO_DELAY } from '../../constants/time';
import { playAudio } from '../audio/audioActions';
import selectors from '../../rootSelectors';

export const READY_TO_ANIMATE = 'READY_TO_ANIMATE';
export const START_SPEAKING = 'START_SPEAKING';
export const STOP_SPEAKING = 'STOP_SPEAKING';
export const MOVE_AVATAR = 'MOVE_AVATAR';
export const SET_INSTRUCTIONS = 'SET_INSTRUCTIONS';
export const SET_POST_AUDIO_CALLBACK_NAME = 'SET_POST_AUDIO_CALLBACK_NAME';
export const SET_OWLY_CAN_SPEAK = 'SET_OWLY_CAN_SPEAK';
export const SET_ANIMATE_ALEX = 'SET_ANIMATE_ALEX';

export const setReadyToAnimate = () => ({
    type: READY_TO_ANIMATE,
});

export const startSpeaking = () => ({
    type: START_SPEAKING,
});

export const stopSpeaking = () => ({
    type: STOP_SPEAKING,
});

export const moveAvatar = targetPosition => (dispatch, getStore) => {
    const state = getStore();
    return new Promise(resolve => {
        const currentPosition = selectors.getAvatarPosition(state) || targetPosition;
        let cb;
        if (targetPosition === currentPosition) {
            cb = null;
            resolve();
        } else {
            cb = resolve;
        }
        return dispatch({
            type: MOVE_AVATAR,
            targetPosition,
            cb,
        });
    });
};

export const setAvatarInstructions = instructions => {
    const instructionArray = Array.isArray(instructions) ? instructions : [instructions];
    return {
        type: SET_INSTRUCTIONS,
        instructions: instructionArray,
    };
};

export const setAvatarPostAudioCallbackName = postAudioCallback => ({
    type: SET_POST_AUDIO_CALLBACK_NAME,
    postAudioCallback,
});

export const playAvatarAudio = (audioFiles, delay = GENERAL_AUDIO_DELAY) => {
    const instructionArray = Array.isArray(audioFiles) ? audioFiles : [audioFiles];
    return dispatch =>
        new Promise(resolve => {
            if (instructionArray && instructionArray.length > 0) {
                return dispatch(
                    playAudio(
                        instructionArray,
                        delay,
                        () => {
                            dispatch(startSpeaking());
                        },
                        () => {
                            dispatch(stopSpeaking());
                            resolve();
                        },
                    ),
                );
            }
            return resolve();
        });
};

export const setOwlyCanSpeak = canSpeak => ({
    type: SET_OWLY_CAN_SPEAK,
    payload: { canSpeak },
});

export const setAnimateAlex = animateAlex => ({
    type: SET_ANIMATE_ALEX,
    payload: animateAlex,
});
